// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"240":"f714fb15","381":"fadbf89e","627":"077e6d61","658":"b3935e34","727":"8a9efca7","836":"3728203f","924":"2f0a6454","964":"69c66e0e","973":"05ed05d3"}[chunkId] + ".js";
};